import axios from 'axios';

export default class Changelog {
    constructor(element) {
        this.element = element;
        this.form = element.querySelector('form');
        this.initEvents();
    }

    initEvents() {
        this.form.querySelector('select').addEventListener('change', e => {
            e.preventDefault();
            this.form.submit();
        })
    }

    getKey() {
        return this.form.querySelector('select').value;
    }

    changeChangelog() {
        this.setLoading();
        let url = window.location.href.split('#')[0];

        axios({
            method: 'get',
            url: url.split('?')[0] + '?product-key=' + this.getKey()
        }).then(r => {
            let parser = new DOMParser();
            let html = parser.parseFromString(r.data, 'text/html');

            this.removeLoading();
            this.getItemContainer().innerHTML = html.querySelector('.changelog .changelog__items').innerHTML;
        });
    }

    getItemContainer() {
        return this.element.querySelector('.changelog__items');
    }

    setLoading() {
        this.getItemContainer().innerHTML = '<span class="icon-spinner -animated"></span> Loading Changelog';
        this.getItemContainer().classList.add('-loading');
    }

    removeLoading() {
        this.getItemContainer().innerHTML = '';
        this.getItemContainer().classList.remove('-loading');
    }

}